import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './index.less';

const cx = classNames.bind(styles);

const defaultProps = {};
const propTypes = {
  name: PropTypes.string.isRequired
};

const Report = ({ id, name }) => <div className={cx('report')}>{name}</div>;

Report.defaultProps = defaultProps;
Report.propTypes = propTypes;
export default Report;



// WEBPACK FOOTER //
// ./src/views/DashboardSettings/components/Report.jsx